import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'
import { ColorPicker } from 'entities/ColorPicker'

export const AccentColorPicker = () => {
  const config = useConfigStore().config
  const isCC = useGlobalStore().isCCSelected
  const updateInterface = useConfigStore().updateInterface
  const color = config?.interfaceConfig?.[getAppName(isCC)]?.colour

  return <ColorPicker color={color || ''} updateColorHandler={updateInterface} />
}
